var amdi18n={"__root":{"selectOption":"Select an option"},"__cs":{"selectOption":"Vybrat volbu"},"__da":{"selectOption":"Vælg en indstilling"},"__de":{"selectOption":"Option auswählen"},"__es":{"selectOption":"Seleccionar una opción"},"__fi":{"selectOption":"Valitse jokin vaihtoehto"},"__fr":{"selectOption":"Sélectionner une option"},"__hr":{"selectOption":"Izaberite opciju"},"__hu":{"selectOption":"Válasszon ki egy beállítást"},"__it":{"selectOption":"Seleziona un'opzione"},"__ja":{"selectOption":"オプションの選択"},"__kk":{"selectOption":"Параметрді таңдаңыз"},"__ko":{"selectOption":"옵션 선택"},"__nb":{"selectOption":"Velg et alternativ"},"__nl":{"selectOption":"Selecteer een optie"},"__no":{"selectOption":"Velg et alternativ"},"__pl":{"selectOption":"Wybierz opcję"},"__pt":{"selectOption":"Selecione uma Opção"},"__pt-br":{"selectOption":"Selecione uma Opção"},"__ro":{"selectOption":"Selectaţi o opţiune"},"__ru":{"selectOption":"Выбрать опцию"},"__sl":{"selectOption":"Izbira možnosti"},"__sv":{"selectOption":"Välj ett alternativ"},"__th":{"selectOption":"เลือกอ็อพชัน"},"__tr":{"selectOption":"Bir Seçenek belirleyin"},"__zh":{"selectOption":"选择选项"},"__zh-cn":{"selectOption":"选择选项"},"__zh-hk":{"selectOption":"選取選項"},"__zh-mo":{"selectOption":"選取選項"},"__zh-sg":{"selectOption":"选择选项"},"__zh-tw":{"selectOption":"選取選項"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;